import { Component, Host, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
    tag: 'sew-ws-tab-navigation-item',
    styleUrl: 'sew-ws-tab-navigation-item.scss',
    shadow: true,
})
export class SewWsTabNavigationItem {
    @Prop({ reflect: true }) active: boolean;

    @Event() tabNavItemClicked: EventEmitter<boolean>;

    render() {
        return (
            <Host onClick={() => this.tabNavItemClicked.emit(true)}>
                <slot></slot>
            </Host>
        );
    }
}
